import Header from "../../../../Components/Header/Header"
import Sidebar from "../../../../Components/Sidebar/Sidebar"
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import DesignationPopup from "./DesignationPopup"
import DeletePopup from "../GardenPopup/DeletePopup"
import WardMasterPopup from "./WardMasterPopup"
import { Loading } from "../../../../Helper/Loading"
import { useDispatch, useSelector } from "react-redux"
import { useAuthState } from "../../../../Helper/Context"
import { WardNameDataDDL } from "../../../../Components/CommonDDL/WardNameDataDDL"

import { WardDeleteAPI, WardTableDataAPI } from "../../../../Redux/SidebarMasterSlice/WardSlice"
import { Pegination } from "../../../../Components/Pegination/Pegination"
import { ZoneDataDDLS } from "../../../../Components/CommonDDL/ZoneDataDDLS"
import { useSearchParams } from "react-router-dom"
import { WardNameGDDL } from "../../../../Components/CommonDDL/WardNameGDDL"

export const WardMaster = () => {

    const userDetails = useAuthState();
    const { UserID, token, M_ProjectTypeID, RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)
    const [WardMasterPopupShow, setWardMasterPopupShow] = useState()
    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)


    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setWardMasterPopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setWardMasterPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setWardMasterPopupShow(false)
    }

    const [ZoneName, setZoneName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }

    const handleDeleteApi = (item) => {
        const data = {
            M_WardID: item.m_WardID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost
        }
        dispatch(WardDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.WardDeleteData)

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setZoneName({
            ...ZoneName,
            ID: 0,
            Label: 'Select...'
        })
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...'
        })
    }

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [WardName.ID, ZoneName.ID])

    useEffect(() => {
        const data = {
            M_ZoneID: ZoneName.ID,
            M_WardID: WardName.ID,
            WardName: '',
            M_ProjectTypeID: RoleID == 1 ? 0 : M_ProjectTypeID,
            M_UsersID: UserID,
            token: token,
            From: From,
            To: To,
        }
        dispatch(WardTableDataAPI({ data }))
    }, [IsPost, To, IsClear, isSearch])

    const { tableData, isLoading } = useSelector(state => state.WardTableData)

    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select Ward",
    // })
    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId}
                        active='wardmaster' listActive="masters" />
                    <div className="content">
                        <div className="data_mob">
                            <div className="row  m-1 py-1 pb-4 master_border">
                                <div className="col-12 d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="m-0 ps-1 py-1">Ward Master</h5>

                                    <span style={{ fontSize: "16px", color: "gray", fontWeight: "bold" }}>
                                        Total Count: {tableData && tableData.table && tableData.table.length > 0 ? tableData.table[0].totalCount : 0}
                                    </span>

                                    <div>
                                        {/* <WardMasterPopup
                                            open={WardMasterPopupShow}
                                            handleIsPost={handleIsPost}
                                            Flag='Insert'
                                        /> */}
                                        <i className="fa-solid fa-plus btn btn-secondary"
                                            onClick={handleAddOnClick} style={{ color: "white" }}>
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>
                                <div className="row m-0 ">
                                    <div className="col-12 py-1  rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12  ">

                                            <div className="row py-1 rounded2">

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <ZoneDataDDLS
                                                        ZoneName={ZoneName}
                                                        setZoneName={setZoneName}
                                                    />
                                                
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    {/* <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        Flag='ward'
                                                    /> */}
                                                    <WardNameGDDL
                                                        M_ZoneID={ZoneName?.ID}
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        M_ProjectTypeID={M_ProjectTypeID}
                                                        APIFlag={RoleID == 1 ? "Master" : "UserWiseWard"}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-3 col-lg-3 mt-lg-4 mt-md-4 d-md-flex" >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button>
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>
                                            </div>
                                            <div className="row mob_table table-responsive pt-1">

                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Zone Name</th>
                                                            <th>Ward Name</th>
                                                            <th className="action-col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                                <tr style={{ width: '100%' }}>
                                                                    <td className="sr-no-col" style={{ textAlign: "center" }}>{item.rowNum}</td>
                                                                    <td>{item.zoneName ? item.zoneName : '-'}</td>
                                                                    <td>{item.wardName ? item.wardName : '-'}</td>
                                                                    <td style={{ textAlign: "center", width: '7%' }}>
                                                                        {/* <WardMasterPopup
                                                                            open={WardMasterPopupShow}
                                                                            handleIsPost={handleIsPost}
                                                                            item={item}
                                                                            Flag='Update'
                                                                        /> */}
                                                                        <span>
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleEditOnClick(item)}
                                                                            >
                                                                            </i>
                                                                        </span>

                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))
                                                                :
                                                                <td colSpan={10}>No data found</td>
                                                        }

                                                    </tbody>
                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                {
                    WardMasterPopupShow ?
                        <WardMasterPopup
                            open={WardMasterPopupShow}
                            // popupHeading="Location Name"
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }
            </div>
        </>
    )
}
